import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Get Clerk publishable key from environment
const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Allow app to run without Clerk for local development
const ClerkWrapper = ({ children }) => {
  if (!PUBLISHABLE_KEY) {
    console.warn('Clerk publishable key not found. Running without authentication.');
    return children;
  }
  return (
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      {children}
    </ClerkProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkWrapper>
      <App />
    </ClerkWrapper>
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Election Fabric is ready for offline use!');
  },
  onUpdate: (registration) => {
    console.log('New version available. Please refresh.');
    // Show update notification to user
    if (window.confirm('A new version of Election Fabric is available. Refresh to update?')) {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    }
  }
});
